import { useCountry } from '@/hooks/use-country';

export const isLocalSource = (localSource?: String) => {
  const { isKR } = useCountry();
  if (isKR) return false;
  return localSource === '1';
};
